import { render, staticRenderFns } from "./UserAccount2.vue?vue&type=template&id=b1fc06d8&"
import script from "./UserAccount2.vue?vue&type=script&lang=js&"
export * from "./UserAccount2.vue?vue&type=script&lang=js&"
import style0 from "./UserAccount2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports